import React, { FC } from 'react';
import styles from '../index.module.scss';
import { useWorkspacesStatistic } from 'src/models/workspace/hooks';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'src/common';

interface IProps {
  statusId: string;
}

export const BoardColumnFooter: FC<IProps> = ({ statusId }) => {
  const { t } = useTranslation();
  const { data: stats, loading } = useWorkspacesStatistic();
  const statusEstimatedData = (stats?.contractValueSums || []).find(stat => stat.statusId === statusId);

  return (
    <div className={styles.statusFooter}>
      <div className={styles.statusValue}>
        <span className={styles.statusValueLabel}>{t('BidSpaces.value')}: </span>
        {loading ? (
          <Spinner />
        ) : (
          // TODO: BlockCurrency ?
          <span className={styles.statusCurrency}>
            {statusEstimatedData
              ? `${t('Common.Format.formatNumber', { number: statusEstimatedData.valueSum / 1000000 })} MSEK`
              : '—'}
          </span>
        )}
      </div>
    </div>
  );
};

export default BoardColumnFooter;
